export const statusColorMap = {
  Pending: "pending",
  Successful: "success",
  Failed: "error"
}
